<template>
    <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="max-w-md mx-auto mt-10">

      <div class="mb-6">
        <div class="relative">
          <input 
            v-model="barcodeSearch" 
            type="text" 
            :placeholder="$t('core.barcode_search') + '...'" 
            class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            @keyup.enter="searchItemfromBarcode"
            autofocus
          >
          <div class="absolute right-3 top-3 text-gray-400">
            <i class="fa fa-search"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="space-y-4">
      <div
        v-for="order in groupedOrders"
        :key="order.numero_ordine_cliente"
        class="border rounded-2xl shadow bg-white"
      >
        <!-- Header -->
        <div
          class="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50"
          @click="toggleOrder(order.numero_ordine_cliente)"
        >
          <div>
            <p class="font-semibold">
              Ordine Cliente #{{ order.numero_ordine_cliente }}
            </p>
            <p class="text-sm text-gray-500">Anno: {{ order.anno }}</p>
          </div>

          <div class="flex items-center gap-4">
            <span
              class="px-2 py-1 rounded text-xs"
              :class="order.confermato ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
            >
              Confermato completamente: {{ order.confermato ? "Sì" : "No" }}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="w-6 h-6 transform transition-transform duration-300"
              :class="{ 'rotate-180': isExpanded(order.numero_ordine_cliente) }"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        <!-- Dettaglio -->
        <transition name="fade">
          <div v-if="isExpanded(order.numero_ordine_cliente)" class="p-4 border-t">
            <table class="w-full text-left border-collapse">
              <thead class="bg-gray-100">
                <tr>
                  <th class="p-2">Collo</th>
                  <th class="p-2">Descrizione</th>
                  <th class="p-2">Barcode</th>
                  <th class="p-2">Confermato</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in order.rows"
                  :key="row.barcode"
                  class="border-t hover:bg-gray-50"
                >
                  <td class="p-2">{{ row.numero_collo }}</td>
                  <td class="p-2">{{ row.descrizione }}</td>
                  <td class="p-2">{{ row.barcode }}</td>
                  <td class="p-2">
                    <span
                      class="px-2 py-1 rounded text-xs"
                      :class="row.confermato === '1' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
                    >
                      {{ row.confermato === "1" ? "Sì" : "No" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </transition>
      </div>

      <div class="fixed left-0 right-0 bottom-0 flex justify-center items-center pointer-events-none">
        <div class="flex gap-2 pointer-events-auto bg-white w-full px-4 py-3 justify-center">
          <button
            class="text-white bg-blue-400 dark:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            @click="onConfermaClick"
          >
            {{ $t('actions.confirm') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>

import { Link, useForm, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Datepicker from 'vue3-datepicker';
import { format } from 'date-fns';
import axios from 'axios';

export default {
  components: {
    Link,
    BreadCrumbs,
    Datepicker
  },
  data() {
    return {
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.ricezione-veneta'),
          href: route('modules.home', 'ricezione-veneta'),},
        { name: this.$t('modules.ricven.apriricezione'),
          href: route('modules.ricven.apriricezione'), }
      ],
      barcodeSearch: '',
      rows: [],
      expandedOrders: [],
    }
  },
computed: {
    groupedOrders() {
      const map = {}
      for (const row of this.rows) {
        const key = row.numero_ordine_cliente
        if (!map[key]) {
          map[key] = {
            numero_ordine_cliente: key,
            anno: row.anno_ordine_cliente,
            customer_id: row.customer_id,
            rows: [],
          }
        }
        map[key].rows.push(row)
      }
      return Object.values(map).map(order => {
        const sortedRows = order.rows.sort(
          (a, b) => Number(a.numero_collo) - Number(b.numero_collo)
        )
        const allConfirmed = sortedRows.every(r => r.confermato === "1")
        return {
          ...order,
          rows: sortedRows,
          confermato: allConfirmed,
        }
      })
    },
  },
  methods: {
    toggleOrder(orderId) {
      if (this.expandedOrders.includes(orderId)) {
        this.expandedOrders = this.expandedOrders.filter(id => id !== orderId)
      } else {
        this.expandedOrders.push(orderId)
      }
    },
    isExpanded(orderId) {
      return this.expandedOrders.includes(orderId)
    },
    searchItemfromBarcode(){
      let _this = this;

      let found = this.rows.find(x => x.barcode == this.barcodeSearch);

      if (!found)
      {
        axios.post(route('modules.ricven.ordinibarcode'), { barcode: this.barcodeSearch }).
        then((response) => {
          if (response.data.success)
          {
            _this.rows = _this.rows.concat(response.data.orderdata);
            _this.rows.find(x => x.barcode == this.barcodeSearch).confermato = "1";
            _this.barcodeSearch = '';
          }
          else{
            _this.showToast(_this.$t('gm.item_not_found'), 'error');
          }
        });
      }
      else
      {
        found.confermato = "1";
        _this.barcodeSearch = '';
      }
    },
  }
}
</script>
